import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { gql, useMutation } from '@apollo/client';
import { Button } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation';
import { showAlert } from '../../../common/Alert/util';
const SYNC_TESTPRESS_EXAMS_MUTATION = gql`
  mutation SyncTestpressExams($examId: Float!) {
    syncTestpressExams(examId: $examId)
  }
`;

const TestpressAttempts = () => {
  const [examId, setExamId] = useState('');
  const { translate } = useTranslation()
  const dispatch = useDispatch()
  //eslint-disable-next-line
  const [syncExams, { data, loading, error }] = useMutation(SYNC_TESTPRESS_EXAMS_MUTATION);

  const handleSync = async (e) => {
    e.preventDefault();
    if (!examId) {
      showAlert({
        text: translate('testpressTool.addId'),
        status: 'error'
      }, dispatch)
      return;
    }

    try {

      await syncExams({
        variables: {
          examId: parseFloat(examId),
        },
      });
      showAlert({
        text: translate('testpressTool.syncSuccess'),
        status: 'success'
      }, dispatch)
    } catch (err) {
      console.error('Error al sincronizar los exámenes:', err);
      showAlert({
        text: translate('testpressTool.syncError'),
        status: 'error'
      }, dispatch)
    }
  };

  return (
    <div className='d-flex flex-column'>
      <h2 className='font-weight-bold'>{translate('testpressTool.title')}</h2>
      {/* <form onSubmit={handleSync}> */}
      <input className='col-6 mt-2'
        type="number"
        placeholder={translate('testpressTool.placeholder')}
        value={examId}
        onChange={(e) => setExamId(e.target.value)}
      />
      <Button
        color='primary'
        activity={loading}
        className='col-6 mt-2'
        label={translate('testpressTool.button')}
        onClick={handleSync}
        style={{ borderRadius: `${'16px 16px 16px 16px'}` }}>
      </Button>
      {/* </form> */}

    </div>
  );
};

export default TestpressAttempts;
